<script lang="ts">
	export let article;
</script>

{#if article && article.content}
	<div class="my-5 article-container">
		<div class="container mb-5">
			<p>{article.content.introduction}</p>
			{#if article.content.subTitle}
				<div class="text-primary relative border-b border-grey">
					<h3 class="mb-0">{article.content?.subTitle}</h3>
					<div class="absolute border-b mb-0 border-secondary w-[4%] right-0" />
				</div>
			{/if}
		</div>

		{#each article.content?.content ?? [] as comp}
			<section class="mb-5">
				<svelte:component this={comp.svelteComp} blok={comp.CMSComp} />
			</section>
		{/each}
		<div class="mt-7">
			<div class=" relative border-b border-grey">
				<div class="absolute border-b mb-0 border-secondary w-[4%] right-0" />
			</div>
		</div>
	</div>
{/if}

<style lang="postcss">
	.article-container :global(h2) {
		text-align: start;
		margin: 2.5rem 0;
	}
	:global(.article-container h3, .article-container h4) {
		margin: 2.5rem 0;
	}
	.article-container :global(h2 span:before) {
		content: none;
	}
	.article-container :global(p) {
		font-size: 1.25rem;
		line-height: 1.85rem;
		margin-bottom: 2rem;
		padding: 0;
	}
</style>
